import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from '@app/components/app.common.module';
import { QuoteRoutingModule } from './quote-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ListOpenQuoteComponent } from './open-quote/list-open-quote/desktop/list-open-quote.component';
import { ListQuoteStandardWrapperComponent } from './standard-quote/list-quote-standard/list-quote-standard-wrapper.component';
import { ClientOpenComponent } from './open-quote/clients/desktop/client-open.component';
import { CalculateDiroViewComponent } from './open-quote/deals/calculate-diro-view/calculate-diro-view.component';
import { CalculateDiroComponent } from './open-quote/deals/calculate-diro/desktop/calculate-diro.component';
import { DealsComponent } from './open-quote/deals/deals.component';
import { HeaderDealComponent } from './open-quote/deals/header-deal/desktop/header-deal.component';
import { InsuranceFormComponent } from './open-quote/deals/insurance-form/desktop/insurance-form.component';
import { QuoteComponent } from './open-quote/deals/quote/quote.component';
import { SpecialPaymentsComponent } from './open-quote/deals/special-payments/special-payments.component';
import { FinancialServiceComponent } from './open-quote/financial-service/desktop/financial-service.component';
import { ClientWrapperComponent } from './standard-quote/client/client-wrapper.component';
import { FinancialProductWrapperComponent } from './standard-quote/deals-standard-quote/financial-product/financial-product-wrapper.component';
import { ResultQuoteWrapperComponent } from './standard-quote/deals-standard-quote/result/result-wrapper.component';
import { NewOpenQuoteComponent } from './open-quote/new-open-quote.component';
import { NewStandardQuoteComponent } from './standard-quote/new-standard-quote.component';
import { ModelsWrapperComponent } from './standard-quote/models/models-wrapper.component';
import { AccessoriesComponent } from './standard-quote/accessories/accessories.component';
import { ModalStatusComponent } from './open-quote/deals/modal-status/modal-status.component';
import { NewDealStandardQuoteWrapperComponent } from './standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-wrapper.component';
import { RowDealStandardQuoteWrapperComponent } from './standard-quote/deals-standard-quote/row-deal-standard-quote/row-deal-standard-quote-wrapper.component';
import { FinancialServiceStandardWrapperComponent } from './standard-quote/financial-service-standard/financial-service-standard-wrapper.component';
import { StandardClientsViewWrapperComponent } from './standard-quote/read-only/clients-view/clients-view-wrapper.component';
import { ColumnDealStandardWrapperComponent } from './standard-quote/deals-standard-quote/column-deal-standard/column-deal-standard-wrapper.component';
import { ListSpecialPaymentsGracePeriodWrapperComponent } from './standard-quote/deals-standard-quote/list-special-payments-grace-period/list-special-payments-gp-wrapper.component';
import { QuoteResultComponent } from './standard-quote/deals-standard-quote/result/result-quote/quote-result.component';
import { CoverageResultComponent } from './standard-quote/deals-standard-quote/result/result-coverage-marsh/coverage-result.component';
import { FinancialServiceViewWrapperComponent } from './standard-quote/read-only/financial-service-view/financial-service-view-wrapper.component';
import { ModelsViewWrapperComponent } from './standard-quote/read-only/models-view/models-view-wrapper.component';
import { AccessoryComponent } from './standard-quote/accessories/accessory/accessory.component';
import { PaymentsStandardQuoteWrapperComponent } from './standard-quote/deals-standard-quote/payments-standard-quote/payments-standard-quote-wrapper.component';
import { ListSpecialPaymentsGracePeriodOpenComponent } from './open-quote/deals/list-special-payments-periods/desktop/list-special-payments-grace-period-open.component';
import { ViewDealStandardQuoteWrapperComponent } from './standard-quote/deals-standard-quote/view-deal-standard-quote/view-deal-standard-quote-wrapper.component';
import { AccessoriesListComponent } from './standard-quote/read-only/accessories-list/accessories-list.component';
import { AccessoryViewComponent } from './standard-quote/read-only/accessories-list/accessory-view/accessory-view.component';
import { ModalDiroLoginComponent } from './open-quote/deals/modal-diro-login/modal-diro-login.component';
import { FinancialSetupComponent } from './standard-quote/catalogs/financial-setup/financial-setup.component';
import { popperVariation, provideTippyConfig, provideTippyLoader, tooltipVariation } from '@ngneat/helipopper/config';
import { TippyDirective } from '@ngneat/helipopper';
import { SubBrandComponent } from './standard-quote/catalogs/sub-brand/sub-brand.component';
import { ClientOpenMobileComponent } from '@app/pages/quote/open-quote/clients/mobile/client-open-mobile.component';
import { InsuranceFormMobileComponent } from '@app/pages/quote/open-quote/deals/insurance-form/mobile/insurance-form-mobile.component';
import { HeaderDealMobileComponent } from '@app/pages/quote/open-quote/deals/header-deal/mobile/header-deal-mobile.component';
import { ListOpenQuoteMobileComponent } from '@app/pages/quote/open-quote/list-open-quote/mobile/list-open-quote-mobile.component';
import { FinancialServiceMobileComponent } from '@app/pages/quote/open-quote/financial-service/mobile/financial-service-mobile.component';
import { CalculateDiroMobileComponent } from '@app/pages/quote/open-quote/deals/calculate-diro/mobile/calculate-diro-mobile.component';
import { ListSpecialPaymentsGracePeriodOpenMobileComponent } from '@app/pages/quote/open-quote/deals/list-special-payments-periods/mobile/list-special-payments-gp-mobile.component';
import { ConfirmationDialog } from '@app/pages/quote/standard-quote/models/confirmationDialog';
import { ClientOpenQuoteWrapper } from '@app/pages/quote/open-quote/clients/client-wrapper.component';
import { FinancialServiceOpenQuoteWrapper } from '@app/pages/quote/open-quote/financial-service/financial-service-wrapper.component';
import { CalculateDiroOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/calculate-diro/calculate-diro-wrapper.component';
import { ListOpenQuoteWrapper } from '@app/pages/quote/open-quote/list-open-quote/list-open-quote-wrapper.component';
import { HeaderDealOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/header-deal/header-deal-wrapper.component';
import { InsuranceFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/insurance-form/insurance-form-wrapper.component';
import { ListSpecialPaymentsGracePeriodOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/list-special-payments-periods/list-special-payments-gp-wrapepr.component';
import { InsuranceDesktopComponent } from '@app/pages/quote/insurance/insurance/desktop/insurance-desktop.component';
import { InsuranceFlexComponent } from '@app/pages/quote/insurance/insurance-flex/desktop/insurance-flex-desktop.component';
import { DataSelectIdDirective } from '@app/directives/dealer.directive';
import { SelectClientModalComponent } from '@app/components/client-select-modal/client-select-modal.component';
import { ClientFormModalComponent } from '@app/components/client-form-modal/client-form-modal.component';
import { InsuranceComponentWrapper } from '@app/pages/quote/insurance/insurance/insurance-wrapper.component';
import { InsuranceMobileComponent } from '@app/pages/quote/insurance/insurance/mobile/insurance-mobile.component';
import { InsuranceFlexMobileComponent } from '@app/pages/quote/insurance/insurance-flex/mobile/insurance-flex-mobile.component';
import { SelectClientModalMobileComponent } from '@app/components/client-select-modal-mobile/client-select-modal-mobile.component';
import { ClientFormModalMobileComponent } from '@app/components/client-form-modal-mobile/client-form-modal-mobile.component';
import { FinancialServiceViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/desktop/financial-service-view-desktop.component';
import { FinancialServiceViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/mobile/financial-service-view-mobile.component';
import { StandardClientsViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/clients-view/desktop/clients-view-desktop.component';
import { StandardClientsViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/clients-view/mobile/clients-view-mobile.component';
import { ModelsViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/models-view/desktop/models-view-desktop.component';
import { ModelsViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/models-view/mobile/models-view-mobile.component';
import { ClientDesktopComponent } from '@app/pages/quote/standard-quote/client/desktop/client-desktop.component';
import { ClientMobileComponent } from '@app/pages/quote/standard-quote/client/mobile/client-mobile.component';
import { ModelsDesktopComponent } from '@app/pages/quote/standard-quote/models/desktop/models-desktop.component';
import { ModelsMobileComponent } from '@app/pages/quote/standard-quote/models/mobile/models-mobile.component';
import { ListQuoteStandardDesktopComponent } from '@app/pages/quote/standard-quote/list-quote-standard/desktop/list-quote-standard-desktop.component';
import { ListQuoteStandardMobileComponent } from '@app/pages/quote/standard-quote/list-quote-standard/mobile/list-quote-standard-mobile.component';
import { ListStandardQuotePageComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-standard-quote-page.component';
import { DealsStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/deals-standard-quote-wrapper.component';
import { DealsStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/desktop/deals-standard-quote-desktop.component';
import { DealsStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/mobile/deals-standard-quote-mobile.component';
import { RowDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/desktop/row-deal-standard-quote-desktop.component';
import { RowDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/mobile/row-deal-standard-quote-mobile.component';
import { ViewDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/desktop/view-deal-standard-quote-desktop.component';
import { ViewDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/mobile/view-deal-standard-quote-mobile.component';
import { NewDealStandardQuotePageComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-page.component';
import { NewDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/desktop/new-deal-standard-quote-desktop.component';
import { NewDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/mobile/new-deal-standard-quote-mobile.component';
import { FinancialProductDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/desktop/financial-product-desktop.component';
import { FinancialProductMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/mobile/financial-product-mobile.component';
import { FinancialServiceStandardDesktopComponent } from '@app/pages/quote/standard-quote/financial-service-standard/desktop/financial-service-standard-desktop.component';
import { FinancialServiceStandardMobileComponent } from '@app/pages/quote/standard-quote/financial-service-standard/mobile/financial-service-standard-mobile.component';
import { ColumnDealStandardDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/desktop/column-deal-standard-desktop.component';
import { ColumnDealStandardMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/mobile/column-deal-standard-mobile.component';
import { ListSpecialPaymentsGracePeriodDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/desktop/list-special-payments-gp-desktop.component';
import { ListSpecialPaymentsGracePeriodMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/mobile/list-special-payments-gp-mobile.component';
import { PaymentsStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/desktop/payments-standard-quote-desktop.component';
import { PaymentsStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/mobile/payments-standard-quote-mobile.component';
import { ResultDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/desktop/result-desktop.component';
import { ResultMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/mobile/result-mobile.component';
import { DealViewMobileComponent } from '@app/pages/quote/open-quote/deals/deal-view/mobile/deals-view-mobile.component';
import { DealViewOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-view/deal-view-wrapper.component';
import { DealViewComponent } from '@app/pages/quote/open-quote/deals/deal-view/desktop/deal-view.component';
import { DealFormComponent } from '@app/pages/quote/open-quote/deals/deal-form/desktop/deal-form.component';
import { DealFormMobileComponent } from '@app/pages/quote/open-quote/deals/deal-form/mobile/deal-form-mobile.component';
import { DealsFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-form/deal-form-wrapper.component';
import { HeaderInsuranceOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/header-insurance/header-insurance-wrapepr.component';
import { HeaderInsuranceMobileComponent } from '@app/pages/quote/open-quote/deals/header-insurance/mobile/header-insurance-mobile.component';
import { HeaderInsuranceComponent } from '@app/pages/quote/open-quote/deals/header-insurance/desktop/header-insurance.component';
import { DiroIntegrationService } from '@app/pages/quote/open-quote/services/diro-integration.service';
import { OpenQuoteValidationsService } from '@app/pages/quote/open-quote/services/open-quote-validations.service';

@NgModule({
  imports: [
    TippyDirective,
    CommonModule,
    FormsModule,
    AppCommonModule,
    QuoteRoutingModule,
    TranslateModule,
    SubBrandComponent,
    DataSelectIdDirective,
    SelectClientModalComponent,
    SelectClientModalMobileComponent,
    ClientFormModalComponent,
    ClientFormModalMobileComponent,
  ],
  declarations: [
    ListStandardQuotePageComponent,
    ListQuoteStandardWrapperComponent,
    ListQuoteStandardDesktopComponent,
    ListQuoteStandardMobileComponent,
    FinancialSetupComponent,
    NewOpenQuoteComponent,
    NewStandardQuoteComponent,
    ClientWrapperComponent,
    ClientDesktopComponent,
    ClientMobileComponent,
    FinancialProductWrapperComponent,
    FinancialProductDesktopComponent,
    FinancialProductMobileComponent,
    InsuranceDesktopComponent,
    InsuranceFlexComponent,
    ResultQuoteWrapperComponent,
    ResultDesktopComponent,
    ResultMobileComponent,
    FinancialServiceComponent,
    QuoteComponent,
    SpecialPaymentsComponent,
    CalculateDiroComponent,
    CalculateDiroViewComponent,
    ListOpenQuoteComponent,
    ListQuoteStandardWrapperComponent,
    HeaderDealComponent,
    HeaderInsuranceComponent,
    DealFormComponent,
    InsuranceFormComponent,
    DealViewComponent,
    DealsComponent,
    ClientOpenComponent,
    ModelsWrapperComponent,
    ModelsDesktopComponent,
    ModelsMobileComponent,
    AccessoriesComponent,
    ModalStatusComponent,
    ModalDiroLoginComponent,
    NewDealStandardQuotePageComponent,
    NewDealStandardQuoteWrapperComponent,
    NewDealStandardQuoteDesktopComponent,
    NewDealStandardQuoteMobileComponent,
    DealsStandardQuoteWrapperComponent,
    DealsStandardQuoteDesktopComponent,
    DealsStandardQuoteMobileComponent,
    RowDealStandardQuoteWrapperComponent,
    RowDealStandardQuoteDesktopComponent,
    RowDealStandardQuoteMobileComponent,
    ViewDealStandardQuoteWrapperComponent,
    ViewDealStandardQuoteDesktopComponent,
    ViewDealStandardQuoteMobileComponent,
    PaymentsStandardQuoteWrapperComponent,
    PaymentsStandardQuoteDesktopComponent,
    PaymentsStandardQuoteMobileComponent,
    FinancialServiceStandardWrapperComponent,
    FinancialServiceStandardDesktopComponent,
    FinancialServiceStandardMobileComponent,
    StandardClientsViewWrapperComponent,
    StandardClientsViewDesktopComponent,
    StandardClientsViewMobileComponent,
    ColumnDealStandardWrapperComponent,
    ColumnDealStandardDesktopComponent,
    ColumnDealStandardMobileComponent,
    ListSpecialPaymentsGracePeriodWrapperComponent,
    ListSpecialPaymentsGracePeriodDesktopComponent,
    ListSpecialPaymentsGracePeriodMobileComponent,
    CoverageResultComponent,
    QuoteResultComponent,
    FinancialServiceViewWrapperComponent,
    FinancialServiceViewDesktopComponent,
    FinancialServiceViewMobileComponent,
    ModelsViewWrapperComponent,
    ModelsViewDesktopComponent,
    ModelsViewMobileComponent,
    AccessoryComponent,
    AccessoriesListComponent,
    AccessoryViewComponent,
    ConfirmationDialog,
    ListSpecialPaymentsGracePeriodOpenQuoteWrapper,
    ListSpecialPaymentsGracePeriodOpenComponent,
    ListSpecialPaymentsGracePeriodOpenMobileComponent,
    CalculateDiroMobileComponent,
    FinancialServiceMobileComponent,
    ListOpenQuoteMobileComponent,
    HeaderDealMobileComponent,
    HeaderInsuranceMobileComponent,
    DealFormMobileComponent,
    ClientOpenMobileComponent,
    DealViewMobileComponent,
    InsuranceFormMobileComponent,

    ClientOpenQuoteWrapper,
    FinancialServiceOpenQuoteWrapper,
    CalculateDiroOpenQuoteWrapper,
    ListOpenQuoteWrapper,
    DealsFormOpenQuoteWrapper,
    HeaderDealOpenQuoteWrapper,
    HeaderInsuranceOpenQuoteWrapper,
    InsuranceFormOpenQuoteWrapper,
    DealViewOpenQuoteWrapper,
    InsuranceComponentWrapper,
    InsuranceMobileComponent,
    InsuranceFlexMobileComponent,
  ],
  providers: [
    DiroIntegrationService,
    OpenQuoteValidationsService,
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
      duration: [null, 0],
      delay: [600, 0],
    }),
    provideTippyLoader(() => import('tippy.js')),
  ],
})
export class QuoteModule {}
